/* ============================================================
   Bouton "Options" : ouvre/ferme la sidebar (desktop slide-left, mobile drawer-right)
   Gère aussi le changement de tri via les radios sort_choice.
   ============================================================ */

(function () {
  if (typeof window === 'undefined') return;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const wrappers = document.querySelectorAll('[data-section-id] .collection-layout');
    wrappers.forEach((wrapper) => setupWrapper(wrapper));
  }

  function setupWrapper(wrapper) {
    const sidebar = wrapper.querySelector('.collection-sidebar');
    const toggleBtn = wrapper.querySelector('.collection-options-toggle');
    const closeBtn = wrapper.querySelector('[data-collection-sidebar-close]');
    const overlay = wrapper.querySelector('[data-collection-overlay]');

    if (!sidebar || !toggleBtn) return;

    const open = () => {
      wrapper.setAttribute('data-sidebar-open', 'true');
      sidebar.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('collection-sidebar-open');
    };

    const close = () => {
      wrapper.setAttribute('data-sidebar-open', 'false');
      sidebar.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('collection-sidebar-open');
    };

    const toggle = () => {
      const isOpen = wrapper.getAttribute('data-sidebar-open') === 'true';
      if (isOpen) close();
      else open();
    };

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });

    toggleBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        close();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', () => close());
    }

    // Échap pour fermer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && wrapper.getAttribute('data-sidebar-open') === 'true') {
        close();
      }
    });

    setupSortRadios(sidebar);

    // Swipe vers la droite sur mobile pour fermer
    setupMobileSwipeToClose(sidebar, close);
  }

  /** Gère le changement de tri via les radios sort_choice */
  function setupSortRadios(sidebar) {
    const radios = sidebar.querySelectorAll('input[type="radio"][name="sort_choice"]');
    if (!radios.length) return;

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        // Mettre à jour la classe active visuelle
        radios.forEach((r) => {
          const label = r.closest('.facets-sort-list__label');
          if (label) label.classList.toggle('active', r.checked);
        });

        const value = radio.value;
        const url = new URL(window.location.href);

        if (value === 'grouped') {
          // Mode "Par collection" : on retire sort_by (pas de sort_by = mode groupé en Liquid)
          url.searchParams.delete('sort_by');
        } else {
          // Tri Shopify natif : on met sort_by
          url.searchParams.set('sort_by', value);
        }

        // On retire le paramètre 'page' (on revient à la page 1)
        url.searchParams.delete('page');

        // Rechargement complet pour basculer entre les modes
        window.location.href = url.toString();
      });
    });
  }

  /** Swipe vers la droite ferme le drawer mobile */
  function setupMobileSwipeToClose(sidebar, closeFn) {
    let startX = null;
    let startY = null;

    sidebar.addEventListener(
      'touchstart',
      (e) => {
        if (window.innerWidth >= 750) return;
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    sidebar.addEventListener(
      'touchend',
      (e) => {
        if (window.innerWidth >= 750) return;
        if (startX === null) return;
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const dx = endX - startX;
        const dy = endY - startY;
        // Swipe horizontal vers la droite franchement
        if (dx > 80 && Math.abs(dy) < 60) {
          closeFn();
        }
        startX = null;
        startY = null;
      },
      { passive: true }
    );
  }
})();
